export const MODULE = 'MISCELLANEOUS_FEES';
export const REMITTANCE_URI = '/api/v1/administrators/transaction_histories/miscellaneous_fee_payments/generate_report/collections_remittances'
export const DAILY_COLLECTION_URI = '/api/v1/administrators/transaction_histories/miscellaneous_fee_payments/generate_report/daily_collection'

export const GENERATE_MISC_FEE_REPORT = `${MODULE}/GENERATE_MISC_FEE_REPORT`;

export const FORMS = {
  date_from: '',
  date_to: '',
  date: '',
}